import React from 'react';
const ContactSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-contact" });
ContactSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-contact sirius-icon-contact-enhance" });
export default ContactSvg;
